<style lang="less" scoped>

</style>
<template>
  <v-form
    ref="form"
    :value="true"
    style="width: 100%;"
  >
    <!-- hc 申请单 -->
    <v-row>
      <v-col
        cols="4"
      >
        <v-text-field
          v-model="editedItem.name"
          label="申请名称"
          required
          :rules="rules.name"
        />
      </v-col>
      <v-col
        cols="4"
      >
        <v-autocomplete 
          v-model="editedItem.team_id"
          :items="product_teams.filter(item=>!item.del)"
          item-value="id"
          readonly
          disabled
          :item-text="({full_name})=>full_name"
          label="执行部门[系统自动]*"
        />
      </v-col>
      <v-col cols="12">
        <HcSubject 
          ref="hcSubject"
          v-model="editedItem.hc_child_item_arr"
          :parent-detail="parentDetail"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="4"
      >
        <v-text-field
          v-model="editedItem.future_expense"
          label="预计正式员工一年薪资支出金额*"
          type="number"
          required
          :rules="rules.future_expense"
        />
      </v-col>
      <v-col
        cols="8"
      >
        <Uploader 
          v-model="editedItem.bfiles"
          :format="['image/jpeg','pdf','xls','xlsx']"
          label="申请附件"
        />
      </v-col>
      <v-col
        cols="12"
      >
        <v-textarea
          v-model="editedItem.remark"
          clearable
          rows="1"
          clear-icon="mdi-close-circle"
          auto-grow
          label="备注"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
  import { mapGetters } from "vuex";
  import HcSubject from './HcSubject'
  import Uploader from './Uploader'
  import { nonNull, decimalRule, decimalRule_0 } from '../utils'
  export default {
    components: {
      Uploader,
      HcSubject
    },
    props: {
      editedItem: {
        type: Object
      },
      positiveInteger: {
        type: Function
      },
      parentDetail: {
        type: Object
      }
    },
    data() {
      return {
       
      }
    },
    methods: {
      validate() {
        const one = this.$refs.form.validate() // 验证外层表单
        const two = this.$refs.hcSubject.validate() // 验证内部动态表单
        return one && two
      },
      refresh() {
        this.$refs.hcSubject.refresh()
        this.$refs.form.resetValidation()
      },
      addNewItem() {
        this.editedItem.items.push({
          budget_amount:'',
          budget_month:''
        })
      },
      deleteItem(index) {
        this.editedItem.items.splice(index, 1)
      },
      getData() {
        const need_data = [
          'id',
          'name', // 申请名称
          'team_id', // 团队
          'future_expense', // 未来一年的费用预算
          'remark', // 备注
          'bfiles', // 附件
          'order_id',
        ]
        /* ----------- 通用字段 --------- */
        const params = {
          is_headcount: true,
        }
        need_data.forEach(key => {
          params[key] = this.editedItem[key]
        })
        params.bfiles = params.bfiles && params.bfiles.map(item => ({
          id: item.id
        }))
        /* ----------- 条目字段 --------- */
        const hc_child_item_arr = this.editedItem.hc_child_item_arr
        const headcounts = []
        hc_child_item_arr.forEach(hcChildItem => {
          let obj = {}
          const { headcount_type, headcount_total, sequence_name, table_data } = hcChildItem
          obj = { headcount_type, headcount_total, sequence_name }
          obj.items = []
          table_data._value.forEach((item) => {
            if (item.is_sum || !item.title_id) {
              return
            }
            const obj_common = {
              title_id:item.title_id, 
              title_name: this.analysis_leaf_titles_hash[item.title_id].name
            }
            Object.keys(item).forEach(key => {
              if (['is_sum', 'title_id'].includes(key)) {
                return
              }
              if (item[key]) {
                obj.items.push({
                  ...obj_common,
                  budget_amount:Number(item[key]),
                  budget_month:key + '-01'
                }) 
              }
            })
          })
          headcounts.push(obj)
        })
        params.team_id = 14 // 写死
        params.headcounts = headcounts
        return params
      }
    },
    computed: {
      ...mapGetters('async', {
        analysis_leaf_titles: 'analysis_leaf_titles', // 分析
        product_teams: 'product_teams',
        analysis_leaf_titles_hash: 'analysis_leaf_titles_hash'
      }),
      rules() {
        return {
          name: [
            nonNull('申请名称必填')
          ],
          total_amount: [
            nonNull('申请科目金额必填'),
            decimalRule
          ],  
          future_expense: [
            nonNull('预计正式员工一年薪资支出金额必填'),
            decimalRule_0
          ],
        }
      },
    },
  }
</script>